import { render } from "./OrdersViewLab_Component.vue?vue&type=template&id=2af40384&scoped=true"
import script from "./OrdersViewLab_Component.vue?vue&type=script&lang=js"
export * from "./OrdersViewLab_Component.vue?vue&type=script&lang=js"

import "./OrdersViewLab_Component.vue?vue&type=style&index=0&id=2af40384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af40384"]])

export default __exports__